import { useTranslation } from 'react-i18next';

export const keyPrefix = 'event_attributes';
export const useEventAttributesTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    no_data: 'Нет данных',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    no_data: 'No data',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    no_data: 'Sem dados',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    no_data: 'Sin datos',
  },
}) : {}) as Record<string, unknown>;
